import type { ExchangeCurrencyType } from '~/components/exchange/types/exchangeCurrency'

export const exchangeRoubles: ExchangeCurrencyType = {
  currency: 'RUB',
  appearance: {
    mnemocode: 'RUB',
    currencyDigital: 'RUB',
    name: 'Валюта',
    pluralNames: '["Рубль","Рубля","Рублей","Рубли"]',
    hasNotValidStatus: false,
  },
  partner: {
    uid: null,
    name: null,
    processorRegistrationId: null,
    processorRegistrationParams: [
      {
        code: 'RUB',
        value: 'RUB',
      },
    ],
  },
  targetExchangeTerms: null,
}
